import React, { useEffect, useRef, useState } from "react";
import Table from "../ui/VirtualTable";
import Float from "../ui/Float";
import { areAll, bm_date, drawPrice, drawQty, emptyObj, getRowClass, setAll, toPrice } from "../utils/Utils";
import { pubCall } from "../utils/PubSub";
import Space from "../ui/Space";
import { SortIcon } from "../utils/Icons";
import Button from "../ui/Button";
import Checkbox from "../ui/Checkbox";
import Divider from "../ui/Divider";
import dayjs from "dayjs";
import Nav from "../ui/Nav";
import { KBD } from "../utils/Keybindings";
import HistoryFilters from "../popups/HistoryFilters";
import { createModal } from "../hooks/createModal";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import ModalButton from "../ui/ModalButton";

import OrderTrack from "../popups/OrderTrack";
import { showError } from "../ui/Message";
import { render } from "@testing-library/react";
import ToolTip from "../ui/ToolTip";

function InventoryHistory(props) {
    // history
    const { controller = "", filters = {}, state = {}, setFilters = () => { }, togglePubstock = () => { }, onSelectSupplier = () => { }, selected = {}, switchView = () => { }, view = "", route = "", in_stock = false, history = { rows: [], total: 0 }, show_expand = true, WS_ONLY = false } = props;

    const [data, setData] = useState({ ...history });
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState({});
    const min = (view === "history_full") ? false : true;
    const limit = 40;
    const row_key = "history_id";
    const active = (view === "history");
    const init_run = useRef(true);

    useEffect(() => {
        init_run.current = true;
    }, [selected])




    useEffect(() => {

        if (view !== "history" && view !== "history_full") {
            setCurrent({})
            return;
        }
        if (data?.rows.length > 0) {
            setCurrent(data.rows[0])
        }

    }, [data, view])







    useEffect(() => {


        if (!data?.rows?.length && !history?.rows?.length) {
            return;
        }
        setData({ ...history })
    }, [history])

    const showHistoryFilters = () => {
        window.bm_state.value = ROUTES.HISTORY.FILTERS;
        createModal({
            component: <HistoryFilters controller={controller} filters={filters} route={ROUTES.HISTORY.FILTERS} />, closable: true, title: <>History Filters</>, callback: (_filter) => {
                if (_filter) {
                    setFilters({ ..._filter })
                }
                window.bm_state.value = route;
            }
        })
    }


    const drawTrack = () => {


        pubCall("shipment_tracking.getInfos", {
            order_number: current?.order_retno,
            supplier_code: current?.supplier,
            primary_code: current?.primary_code,
            condition_code: current?.condition_code,
            invoice_number: current?.invoice
        }, (_s, _r) => {
            if (_s) {
                createModal({
                    component: <OrderTrack
                        controller={controller}
                        data={_r}
                    />, closable: true, title: <>Order Tracking</>, callback: () => {
                        window.bm_state.value = route;
                    }
                })
            } else {
                showError(_r);
            }
        })



    }




    const history_nav = [
        { key: KBD.ESCAPE, action: () => switchView() },
        { key: KBD.COMMA, action: () => togglePubstock() },
        { key: KBD.ARROW_LEFT, action: () => { (view === "orders") ? switchView("history", "history") : switchView("inventory") } },
        { key: KBD.TAB, action: () => { switchView("inventory", "orders") } },
        { key: KBD.ARROW_RIGHT, action: () => { switchView("inventory", "orders") } },
        { text: "Adj" },
        { text: "Del" },
        { key: KBD.E, text: "Edt", action: () => onSelectSupplier(current) },
        { key: KBD.O, action: () => switchView("orders", "orders") },
        { key: KBD.H, text: "Hst", action: () => showHistoryFilters() },
        { text: "Lbl" },
        { text: "Prt" },
        { text: "Rsv" },
        { text: "Ttl" },
        { text: "View" },
        { text: "Zret" },
    ]

    if (current?.table === "order") {
        history_nav.push({ key: KBD.ALT_T, text: "Alt+Track", inds: [0, 1, 2, 3, 4], action: () => drawTrack() });
    }

    useEffect(() => {

        if (loading || props.loading) {
            return;
        }

        const cleanup = listen(controller, ROUTES.INVENTORY.HISTORY, history_nav);
        return cleanup;
    }, [history_nav, loading, props.loading, current, state])


    //Qty, Stat, Supp, Date, Customer, CustPO#, Order#, Invoice#, Clerk.

    const columns = [

        { min: true, key: "quantity", title: <ToolTip text={"Quantity"}>Qt</ToolTip>, width: 25, render: (e) => drawQty(e) },

        {
            min: true, key: "status", align: "left", title: <><ToolTip text={"Status"}>Stat</ToolTip></>, width: 42, render: (e, f) => {
                return (f.table === "order") ? <u onClick={() => onSelectSupplier(f)}>{e}</u> : e;
            }
        },
        { min: true, key: "supplier", align: "left", title: <>Supp</>, width: 54 },
        {
            min: true, key: "display_date", align: "left", title: <>Date</>, width: 80, render: (e) => {
                return (e) ? dayjs(e).format("MMMDD-YY") : "";
            }
        },
        { min: true, key: "cust_name", align: "left", title: <>Customer</>, width: 121, grow: true },
        { min: true, key: "custpo", align: "left", title: <>CustPO#</>, width: 95 },
        { min: true, key: "order_retno", title: <>Order#</>, width: 54 },
        { min: true, key: "invoice", title: <>Invoice#</>, width: 80 },
        {
            min: true, key: "cashier", align: "left", title: <>C</>, width: 20, render: (e) => {
                return <small style={{ fontSize: "12px" }}>{e}</small>
            }
        },

        {
            min: true, key: "price", title: <>Price</>, width: 44, render: (e) => {
                return <small style={{ fontSize: "12px" }}>{drawPrice(e, false)}</small>
            }
        },
        {
            min: true, key: "discount", title: <>%</>, width: 20, render: (e) => {
                return <small style={{ fontSize: "12px" }}>{e}</small>
            }
        },
        {
            min: true, key: "profit_margin", title: <>pm</>, width: 27, render: (e) => {
                return <small style={{ fontSize: "12px" }}>{e}</small>
            }
        },







    ]


    const drawFilters = () => {


        return (
            <Space size={10}>
                <Checkbox value={areAll(filters, true)} onChange={(e) => {

                    if (areAll(filters, true)) {
                        // set to none
                        let _all_removed = setAll(filters, false);
                        setFilters({ ..._all_removed });
                        return;
                    } else {
                        let _all_added = setAll(filters, true);
                        setFilters({ ..._all_added });
                        return;
                    }


                }} >All</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "held": e })} value={filters.held}>Held</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "sales": e })} value={filters.sales}>Sls</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "prepay": e })} value={filters.prepay}>Prpy</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "orders": e })} value={filters.orders}>Orders</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "returns": e })} value={filters.returns}>Rtrns</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "adjustment": e })} value={filters.adjustment}>Adj</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "quotes": e })} value={filters.quotes}>Qts</Checkbox>
                <Checkbox onChange={(e) => setFilters({ ...filters, "transfers": e })} value={filters.transfers}>Tsfrs</Checkbox>
            </Space>
        )
    }


    const drawHeader = () => {
        return (
            <>
                <div style={{ "padding": "0px 5px", "fontSize": "14px", "lineHeight": "17px" }}>
                    <Float>
                        <div style={{ "height": "21px" }}>History</div>
                        <div>
                            <Space size={12}>
                                {/* {(min && show_expand && <em><a onClick={() => switchView("history_full")}>← View details</a></em>)} */}
                                {drawFilters()}
                                {(!min &&
                                    <Space>
                                        <div className="border-secondary-bg" style={{ "display": "block", "width": ".5px", "height": "30px", "marginTop": "-12px", "marginBottom": "-12px" }}></div>
                                        <ModalButton onClick={() => switchView()} style={{ "marginRight": "-3px" }} value={<>&times;</>} />
                                    </Space>
                                )}
                            </Space>
                        </div>
                    </Float>
                </div>
                <div style={{ "margin": "0px -6px" }}>
                    {/* <InventoryOrders
                        is_history={true}
                        filters={filters}
                        setFilters={setFilters}
                        setSelected={setSelected}
                        loading={props.loading}
                        other_conditions={fullData.other_conditions}
                        selected={selected}
                        setFullData={setFullData}
                        fullData={fullData}
                        signal={signal}
                        cost={fullData?.stock?.cost}
                        sell_price={fullData?.stock?.price}
                        state={state}
                        pending_orders={fullData.pending_orders || []}
                        pubstock={fullData?.pubstock}
                        switchView={switchView}
                        route={ROUTES.INVENTORY.ORDER}
                    /> */}
                </div>
            </>
        )
    }



    const fetchHistory = (append = false) => {


        if (init_run?.current) {
            init_run.current = false;
            return;
        }




        if (!selected?.stock_id && !selected?.stock_data?.stock_id) { return; }



        if (!in_stock) {
            setCurrent({});
            setData({ rows: [], total: 0 });
            return;
        }

        let _params = { ...filters };

        _params.primary_code = selected?.primary_code;
        _params.condition_code = selected?.condition_code;
        // Not used for now...
        _params.only_recent = false;
        _params.limit = limit;

        if (append) {
            _params.offset = data?.rows?.length || 0;

        } else {
            _params.offset = 0;
        }


        // No code, don't send
        if (!_params.primary_code) { return; }


        // Debounce...
        setLoading(true);


        pubCall("history.getItemAll", _params, (_s, _r) => {
            if (_s) {
                setData(prev => {
                    if (append && prev?.rows?.length) {
                        return {
                            ..._r,
                            rows: [...prev.rows, ..._r.rows]
                        };
                    } else {
                        return _r;
                    }
                });

                if (!min && _r?.rows.length > 0) {
                    setCurrent(_r?.rows[0]);
                } else {
                    setCurrent({});
                }
                setLoading(false)
            }
        })
    }


    useEffect(fetchHistory, [filters, min, selected])


    useEffect(() => {


        if (!current?.[row_key] || !data?.rows?.length || loading) return;

        const index = data.rows.findIndex(item => item?.[row_key] === current?.[row_key]);

        const buffer = 4;

        if (data.rows.length < data.total && index >= data.rows.length - buffer) {
            fetchHistory(true);
        }
    }, [current, data.rows]);

    const next = (_rows = 1) => {

        const d = data?.rows || [];

        if (d.length === 0) { setCurrent({}); return; }
        const nextIndex = d.findIndex(item => item?.[row_key] === current?.[row_key]) + _rows;
        if (d.length <= nextIndex) { setCurrent(d[d.length - 1]); }
        if (nextIndex < d.length) { setCurrent(d[nextIndex]); }
    };

    const prev = (_rows = 1) => {
        const d = data?.rows || [];

        if (d.length === 0) { setCurrent({}); return; }
        const prevIndex = d.findIndex(item => item?.[row_key] === current?.[row_key]) - _rows;
        if (prevIndex < 0) { setCurrent(d[0]); }
        if (prevIndex >= 0) { setCurrent(d[prevIndex]); }
    };

    const ind = data?.rows.findIndex(item => item?.[row_key] === current?.[row_key]) || 0;



    return (
        <div style={{ "height": "100%" }}>
            <Table
                controller={controller}
                medium={true}
                offset={0}
                rowfade={true}
                row_height={25}
                tweak={59}
                next={next}
                route={route}
                row_key={row_key}
                prev={prev}
                scrollbar={true}
                scrollindicator={true}
                infinite={true}
                onLoadMore={(_start, _end, _prepend) => {
                    if (_prepend) {
                        // not implemented...
                    } else {
                        if (data?.length > 0) {
                            fetchHistory(true)
                        }
                    }
                }}
                className={(min) ? "history_table" : ""}
                current={current}
                onRowClick={(e) => (min) ? () => { } : setCurrent(e)}
                height={100}
                columns={(min) ? columns.filter(item => item.min) : columns}
                data={data?.rows || []}
                width={(min) ? 608 : 1410}
                rowClass={getRowClass}
                columnHeaderClass="column-header-noradius"
                header={drawHeader()}
                headerClass="ui-table-header-order"
                fullHeight
            />
            {(active &&
                <div className="abs-nav" style={{ 'height': "30px" }}>
                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={history_nav} />
                    </Space>
                </div>
            )}

        </div>
    )


}

export default React.memo(InventoryHistory)